import { TextFieldLayoutItem, RadioButtonLayoutItem } from 'models/InputLayoutItem';
import { MultiFormCardHeader } from 'components/MultiFormCardHeader';
import * as yup from 'yup';
import { CreateFormLayout } from 'components/create-form/CreateFormLayout';
import { StorageServiceImpl } from 'services/storage-service/StorageServiceImpl';
import { FORM, LAYOUT_ITEM, PORTABILITY_FORM_DATA_KEY_STORAGE } from 'constants/FormConstants';
import { DATA_LAYERS, DATA_LAYER_PAGE } from 'constants/DataLayers';
import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

const storageService = new StorageServiceImpl();

export const PortabilidadPaso2 = () => {
	const firstName = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.FIRST_NAME,
		sessionStorage
	);
	const email = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.EMAIL,
		sessionStorage
	);
	const phone = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.PHONE,
		sessionStorage
	);
	const touchPointSelected = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.TOUCH_POINT_SELECTED,
		sessionStorage
	);

	const fields: any[] = [
		{
			label: 'Correo electronico',
			defaultValue: email ? email : '',
			name: FORM.EMAIL,
			type: LAYOUT_ITEM.TYPE.INPUT,
			placeholder: 'Ej: mail@mail.cl',
			validation: yup.string().email('Ingrese un email válido').required('Campo Requerido'),
		} as TextFieldLayoutItem,
		{
			label: 'Teléfono',
			defaultValue: phone ? phone : '',
			name: FORM.PHONE,
			type: LAYOUT_ITEM.TYPE.INPUT,
			prefix: '+56 ',
			placeholder: '9 8765 4321',
			mask: '# ### ### ##',
			validation: yup
				.number()
				.typeError('Ingrese un número válido')
				.min(111111111, 'Ingrese un número válido')
				.max(999999999, 'Ingrese un número válido')
				.notOneOf([999999999], 'Ingrese un número válido')
				.required('Campo Requerido'),
		} as TextFieldLayoutItem,
		{
			defaultValue: touchPointSelected ? touchPointSelected : 'WHATSAPP',
			type: LAYOUT_ITEM.TYPE.RADIO_BUTTON,
			label: 'Prefiero que me contacten por:',
			name: FORM.TOUCH_POINT_SELECTED,
			options: [
				{
					label: 'WhatsApp',
					value: 'WHATSAPP',
				},
				{
					label: 'Teléfono',
					value: 'PHONE',
				},
				{
					label: 'Correo',
					value: 'EMAIL',
				},
			],
		} as RadioButtonLayoutItem,
	];

	useEffect(
		() => {
			TagManager.dataLayer({
				dataLayer: DATA_LAYERS.get(DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_2),
			});
		},
		//eslint-disable-next-line
		[]
	);

	return (
		<div>
			<MultiFormCardHeader
				title={`Un gusto, ${firstName ? firstName : ''}`}
				body="Para empezar, por favor indícanos un correo y teléfono de contacto para comunicarnos contigo"
			/>

			<CreateFormLayout key={fields.length} fields={fields} />
		</div>
	);
};
